export default __webpack_public_path__ + "static/media/logo_mobile.05366c45.png";